import { shape, required, items, fromModel, concatFailure, lessThan, greaterThan } from "@totalsoft/pure-validations";
export const validatorPersonWorkplaces = concatFailure(
    items(
      fromModel(model =>
        shape({
          professionId: required,
          positionId: required,
          employerId: required,
          dateFrom: [required, lessThan(model.dateTo)] |> concatFailure,
          dateTo: [required, greaterThan(model.dateFrom)] |> concatFailure
        })
      )
    )
  );